import { DiscountType } from '@ca/common'
import { IconName } from '@ui/elements/Icon'
import { HighlightVariant } from '@ui/effects/Highlights/styles'
import { DiscountOptionStatus } from './DiscountOption'

export const discountToIcon: Record<DiscountType, IconName> = {
  credit: 'coins',
  coupon: 'discount',
  'gift-card': 'gift',
  referral: 'heart-handshake',
  promotion: 'award',
}

export const highlightVariant: Record<DiscountOptionStatus, HighlightVariant> =
  {
    default: 'default',
    active: 'success',
    disabled: 'disabled',
    attention: 'attention',
  }
